import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Divider,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import AppConfig from "appConfig";
import usePageTitle from "app/pageTitle";

function VisitTrackersPage() {
  const pageTitle = "Visit Trackers";
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [trackers, setTrackers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/visits/trackers.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setTrackers(result.data.data.trackers);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} mb={5}>
        <MDBox mb={3}>
          <Card>
            <MDBox p={2}>
              <MDBox
                display="flex"
                justifyContent="space-between"
                px={1}
                alignItems="center"
              >
                <MDBox pt={0.5}>
                  <Icon>tour</Icon>
                </MDBox>
                <MDBox>
                  <MDTypography variant="h6" fontWeight="bold">
                    Assigned Trackers
                  </MDTypography>
                </MDBox>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
        <MDBox mt={0}>
          {trackers.length > 0 ? (
            <MDBox>
              {trackers.map((tracker) => (
                <MDBox
                  mb={3}
                  onClick={() => {
                    navigate(`/visits/trackers/${tracker.reference}`);
                  }}
                >
                  <Card>
                    <MDBox p={1.5}>
                      <MDBox display="flex" justifyContent="space-between">
                        <MDBox>
                          <MDTypography variant="body2" fontWeight="light"fontSize={10}>
                            ACCOUNT
                          </MDTypography>
                          <MDTypography variant="body2" fontWeight="regular" fontSize={13}>
                            {tracker.account.name}
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <img
                            src={`${AppConfig.api_media_url}${tracker.account.icon}`}
                            width="24px"
                          />
                        </MDBox>
                      </MDBox>
                      <Divider />
                      <MDBox>
                        <MDTypography
                          variant="h6"
                          fontSize={16}
                          display="flex"
                          alignItems="center"
                          gap={2}
                        >
                          <Icon color="dark">tour</Icon>
                          {tracker.title}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              ))}
            </MDBox>
          ) : (
            <Card>
              <MDBox align="center" p={2}>
                <MDTypography fontSize={48}>
                  <Icon>warning</Icon>
                </MDTypography>
                <MDTypography variant="body2">
                  You have not been assigned to any visit trackers yet.
                </MDTypography>
              </MDBox>
            </Card>
          )}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default VisitTrackersPage;
